/* import __COLOCATED_TEMPLATE__ from './canceled-invitation-content.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();